import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import alertGiftPng from '@/assets/landing/alert-gift.png'
import taiChi4049Webp from '@/assets/landing-age-selection/tai-chi/40-49.webp'
import taiChi5059Webp from '@/assets/landing-age-selection/tai-chi/50-59.webp'
import taiChi6069Webp from '@/assets/landing-age-selection/tai-chi/60-69.webp'
import taiChi7080Webp from '@/assets/landing-age-selection/tai-chi/70-80.webp'

const schema: LandingScreenSchema = {
	order: ['LandingAlert', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingAlert: ({ $t }): LandingComponentsConfig['LandingAlert'] => ({
			text: $t('female_yoga.pages.landing.alert_text'),
			icon: alertGiftPng,
			backgroundColor: 'var(--Fill-Accent-16)',
			customStyles: {
				marginTop: 'var(--size-20)',
			},
		}),

		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('male-tai-chi-yoga.age-picker.title'),
			size: 'large',
			uppercase: true,
			customStyles: {
				marginTop: '2rem',
			},
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'blue',
			ageRanges: [
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: taiChi4049Webp,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: taiChi5059Webp,
				},
				{
					value: 60,
					analyticValue: '60-69',
					label: $t('female_yoga.pages.landing.age_range.60_69'),
					img: taiChi6069Webp,
				},
				{
					value: 70,
					analyticValue: '70+',
					label: $t('female_yoga.pages.landing.age_range.70_80'),
					img: taiChi7080Webp,
				},
			],
			otherAgesButton: {
				data: { value: 18, analyticValue: '18-39' },
				text: $t('female_yoga.pages.landing.im_young'),
			},
		}),
	},
}

export default schema
